import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, utility } = useTheme();

  return {
    loader: (isInline, id, isFilter) => css`
      margin-left: 4px;
      text-align: center;
      align-self: center;
      ${isFilter &&
      css`
        margin: 2rem 1rem;
        ${breakpoints.m} {
          margin: 2rem 5rem;
        }
        flex: 1;
        svg {
          max-width: 120px !important;
          height: 120px !important;
        }

        p {
          color: ${colors.red};
          font-size: 1.125rem;
          font-weight: 500;
          line-height: 26px;
          letter-spacing: -0.18px;
          ${breakpoints.m} {
            letter-spacing: -0.24px;
          }

          @media (min-width: 769px) and (max-width: 1024px) {
            font-size: 1.125rem;
          }
          @media (min-width: 1024px) {
            font-size: 1.5rem;
          }
        }
      `}

      svg {
        width: 100%;
        max-width: 85px;
      }

      ${isInline &&
      css`
        svg {
          padding-right: ${spacing.xs};
          max-width: 50px;
          width: 15%;
          margin-left: 10rem;
          margin-bottom: -1.75rem;
        }
      `}

      #${id} {
        animation: logo-animation 3000ms linear infinite normal forwards;
      }

      @keyframes logo-animation {
        0% {
          transform: translate(45.669999px, 46.839997px) rotate(0deg);
        }

        100% {
          transform: translate(45.669999px, 46.839997px) rotate(1800deg);
        }
      }
    `,
    text: (hasText, inline) => css`
      color: ${colors.white};
      ${!hasText && utility.checkboxHidden}

      &:focus {
        outline: none;
      }

      ${hasText &&
      inline &&
      css`
        text-align: center;
        font-weight: 400;
        width: 190px;
      `}
    `,
  };
};
